export default __webpack_public_path__ + "f468f235ec4f2ccfa0f76a07979292b4.png";